import mainCaller from './mainCaller';

export async function createBranch(data, token) {
  return await mainCaller(`admin/api/v1/branches`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
}

export async function updateBranch(data, branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'multipart/form-data',
  });
}

export async function updateBranchCloseDays(data, branchId, year, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/closed-days?year=${year}`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });
}

export async function getBranchCloseDays(branchId, year, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/closed-days?year=${year}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

export async function updateBranchPolicy(data, branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/policies`, 'PATCH', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

export async function updateBranchTime(data, branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/calender/setting`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

export async function getBranchTime(branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/calender/setting`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

export async function updateBranchEntranceTime(data, branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/entrance-time`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

export async function getBranchEntranceTime(branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/entrance-time`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

/**
 * 레슨 설정 조회
 * @param {number} branchId - 지점 ID
 * @param {string} CourseClassType - PRIVATE_LESSON 또는 GROUP_LESSON
 * @param {string} token - 인증 토큰
 */
export async function getLessonSettings(branchId, CourseClassType, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/lesson-settings/${CourseClassType}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

/**
 * 레슨 설정 저장
 * @param {object} data - 레슨 설정 데이터
 * @param {string} token - 인증 토큰
 */
export async function saveLessonSettings(data, token) {
  return await mainCaller(`admin/api/v1/branches/lesson-settings`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}
